import { __OBJECT_STRUCTURE_GetList } from "../common/ObjectStructures/Trasnversal";
import { SET_BOARD_DATASERIES, UPDATE_BOARD_DATASERIE, UPDATE_BOARD_DATASERIES_LIST, CLEAR_DATASERIE_CONTEXT } from "./actions/KPI/actions";

const initialState = {
	_dataSeries: __OBJECT_STRUCTURE_GetList(),
};

const boardDataSeriesReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_BOARD_DATASERIES:
			return {
				...state,
				_dataSeries: {
					...state._dataSeries,
					data: action.payload.object
				}
			};
		case  UPDATE_BOARD_DATASERIES_LIST:
			return {
				...state,
				_dataSeries: {
					...state._dataSeries,
					data: action.payload.object,
					fireUpdate: action.payload.update
				}
			};	
		case  UPDATE_BOARD_DATASERIE:
			return {
				...state,
				_dataSeries: {
					...state._dataSeries,
					data: state._dataSeries.data.map(item =>
						item.dataserieId === action.payload.object.dataserieId ? { ...item, ...action.payload.object } : item
					),
					fireUpdate: action.payload.object.update
				}
			};
		case  CLEAR_DATASERIE_CONTEXT:
			return { _dataSeries: __OBJECT_STRUCTURE_GetList() };	
		default:
			return state;
	}
};

export default boardDataSeriesReducer;